import React, { useEffect } from "react";

const Schedule = () => {
    
  useEffect(() => {
    const head = document.querySelector("head");
    const script = document.createElement("script");
    script.setAttribute(
      "src",
      "https://assets.calendly.com/assets/external/widget.js"
    );
    head.appendChild(script);
  });

  return (
      <div id="schedule_form" style={{ justifyContent: "flex-start" }}>

     <div style={{ fontSize: 20, lineHeight: 1.6,  marginTop: 20}}>Thank you for showing your interest in Catax. You have been approved for early
      access to the industry's most robust, holistic crypto currency tax solution. Our team of
       experts will work with you every step of the way. </div> 
        <div
          className="calendly-inline-widget"
          data-url="https://calendly.com/cataxapp/hello"
          style={{
            minWidth: "320px",
            height:1200
          }}
        />
      </div>
  );
};


export default Schedule;